import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from "./components/Header/Header";
import SideNavbar from './components/sideNavbar/SideNavbar';
import DashBoard from './components/dashboard/DashBoard';
import Doctor from './components/doctor/Doctor';
import Patients from './components/patient/Patients';
import Categories from './components/categories/Categories';
import Subcategories from './components/Subcategories/Subcategories';
import Slider from './components/slider/Slider';
import Services from './components/services/Services';
import Reservation from './components/reservation/Reservation';
import Meetings from './components/meetings/Meeting';
import TreatmentPlans from './components/TreatmentPlans/TreatmentPlans';
import Permissions from './components/Permissions/Permissons';
import Copon from './components/copon/Copon';
import Users from './components/users/Users';
import LotalyProgram from './components/LoyaltyProgram/LotalyProgram';
import Questions from './components/Questions/Questions';
import Settings from './components/setting/Settings';
import PublicSettings from './components/setting/PublicSettings';
import ReturnPolicy from './components/setting/ReturnPolicy';
import CopyRights from './components/setting/CopyRights';
import CommonQuestions from './components/setting/CommonQuestions';
import RatingPage from './components/RatingsPage/RatingPage';
import DoctorsProfile from './components/doctor/DoctorsProfile';
import DoctorData from './components/doctor/DoctorData';
import PatientData from './components/patient/PatientData';
import Invoices from './components/invoices/Invoices';
import InvoiceData from './components/invoices/InvoiceData';
import InvoiceView from './components/invoices/InvoiceView';
import InvoicePrint from './components/invoices/InvoicePrint';
import ServiceCodes from './components/services/ServiceCodes';
import ServiceCodeData from './components/services/ServiceCodeData';
import Reports from './components/reports/Reports';
import DailyAppointments from './components/reports/DailyAppointments';
import DoctorRevenue from './components/reports/DoctorRevenue';
import SalesInvoices from './components/reports/SalesInvoices';
import VATReports from './components/reports/VATReports';
import CreditNotes from './components/reports/CreditNotes';
import DoctorAccount from './components/reports/DoctorAccount';
import AddTreatmentPlans from './components/TreatmentPlans/AddTreatmentPlans';
import AddMeetings from './components/meetings/AddMeetings';
import AddUsers from './components/users/AddUsers';
import AddPermissions from './components/Permissions/AddPermissions';
import AddServices from './components/services/AddServices';
import AddQuestions from './components/Questions/AddQuestions';
import LoginPage from './components/login/Login';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import './App.css';
import './components/accounting/accounting.css';
import { AuthProvider, useAuth } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import UpdateServices from './components/services/UpdateServices';
import ChartOfAccounts from './components/accounting/ChartOfAccounts';
import JournalEntries from './components/accounting/JournalEntries';
import Vouchers from './components/accounting/Vouchers';
import AddVoucher from './components/accounting/AddVoucher';
import EditVoucher from './components/accounting/EditVoucher';
import ViewVoucher from './components/accounting/ViewVoucher';
import Banks from './components/accounting/Banks';
import AddBank from './components/accounting/AddBank';
import EditBank from './components/accounting/EditBank';
import ViewBank from './components/accounting/ViewBank';
import BankAccounts from './components/accounting/BankAccounts';
import CashRegisters from './components/accounting/CashRegisters';
import CostCenters from './components/accounting/CostCenters';

function AppContent() {
  const location = useLocation();
  const { isAuthenticated } = useAuth(); 
  const isLoginPage = location.pathname === '/Login';
  return (
    <div className="App">
    {!isLoginPage && isAuthenticated && <Header />}
      <div className="container-fluid">
        <div className="row">
          {!isLoginPage && isAuthenticated && <SideNavbar />}
          <div className="col">
          <ScrollToTop />
            <Routes>
              <Route path="/Login" element={<LoginPage />} />
              <Route path="/" element={<ProtectedRoute element={<DashBoard />} />} />
              <Route path="/dashboard" element={<ProtectedRoute element={<DashBoard />} />} />
              <Route path="/doctor" element={<ProtectedRoute element={<Doctor />} />} />
              <Route path="/patients" element={<ProtectedRoute element={<Patients />} />} />
              <Route path="/categories" element={<ProtectedRoute element={<Categories />} />} />
              <Route path="/subcategories" element={<ProtectedRoute element={<Subcategories />} />} />
              <Route path="/slider" element={<ProtectedRoute element={<Slider />} />} />
              <Route path="/services" element={<ProtectedRoute element={<Services />} />} />
              <Route path="/reservation" element={<ProtectedRoute element={<Reservation />} />} />
              <Route path="/meetings" element={<ProtectedRoute element={<Meetings />} />} />
              <Route path="/treatmentPlans" element={<ProtectedRoute element={<TreatmentPlans />} />} />
              <Route path="/permissions" element={<ProtectedRoute element={<Permissions />} />} />
              <Route path="/copon" element={<ProtectedRoute element={<Copon />} />} />
              <Route path="/users" element={<ProtectedRoute element={<Users />} />} />
              <Route path="/lotalyProgram" element={<ProtectedRoute element={<LotalyProgram />} />} />
              <Route path="/questions" element={<ProtectedRoute element={<Questions />} />} />
              <Route path="/settings" element={<ProtectedRoute element={<Settings />} />}>
                <Route path="publicSettings" element={<ProtectedRoute element={<PublicSettings />} />} />
                <Route path="returnPolicy" element={<ProtectedRoute element={<ReturnPolicy />} />} />
                <Route path="copyRights" element={<ProtectedRoute element={<CopyRights />} />} />
                <Route path="commonQuestions" element={<ProtectedRoute element={<CommonQuestions />} />} />
              </Route>
              <Route path="/ratingPage" element={<ProtectedRoute element={<RatingPage />} />} />
              <Route path="/doctorsProfile/:id" element={<ProtectedRoute element={<DoctorsProfile />} />} />
              <Route path="/doctorData" element={<ProtectedRoute element={<DoctorData />} />} />
              <Route path="/patientData" element={<ProtectedRoute element={<PatientData />} />} />
              <Route path="/invoices" element={<ProtectedRoute element={<Invoices />} />} />
              <Route path="/invoiceData" element={<ProtectedRoute element={<InvoiceData />} />} />
                     <Route path="/invoiceView" element={<ProtectedRoute element={<InvoiceView />} />} />
       <Route path="/invoicePrint" element={<ProtectedRoute element={<InvoicePrint />} />} />
       <Route path="/ServiceCodes" element={<ProtectedRoute element={<ServiceCodes />} />} />
       <Route path="/ServiceCodeData" element={<ProtectedRoute element={<ServiceCodeData />} />} />
       <Route path="/reports" element={<ProtectedRoute element={<Reports />} />} />
       <Route path="/reports/daily-appointments" element={<ProtectedRoute element={<DailyAppointments />} />} />
       <Route path="/reports/doctor-revenue" element={<ProtectedRoute element={<DoctorRevenue />} />} />
       <Route path="/reports/sales-invoices" element={<ProtectedRoute element={<SalesInvoices />} />} />
       <Route path="/reports/vat-reports" element={<ProtectedRoute element={<VATReports />} />} />
       <Route path="/reports/credit-notes" element={<ProtectedRoute element={<CreditNotes />} />} />
       <Route path="/reports/doctor-account" element={<ProtectedRoute element={<DoctorAccount />} />} />
       <Route path="/updateServices" element={<ProtectedRoute element={<UpdateServices />} />} />
       <Route path="/addTreatmentPlans" element={<ProtectedRoute element={<AddTreatmentPlans />} />} />
       <Route path="/addMeetings" element={<ProtectedRoute element={<AddMeetings />} />} />
      <Route path="/addUsers" element={<ProtectedRoute element={<AddUsers />} />} />
      <Route path="/addPermissions" element={<ProtectedRoute element={<AddPermissions />} />} />
          <Route path="/addServices" element={<ProtectedRoute element={<AddServices />} />} />
          <Route path="/addQuestions" element={<ProtectedRoute element={<AddQuestions />} />} />
          <Route path="/chart-of-accounts" element={<ProtectedRoute element={<ChartOfAccounts />} />} />
          <Route path="/journal-entries" element={<ProtectedRoute element={<JournalEntries />} />} />
          <Route path="/vouchers" element={<ProtectedRoute element={<Vouchers />} />} />
          <Route path="/vouchers/add" element={<ProtectedRoute element={<AddVoucher />} />} />
          <Route path="/vouchers/edit/:id" element={<ProtectedRoute element={<EditVoucher />} />} />
          <Route path="/vouchers/view/:id" element={<ProtectedRoute element={<ViewVoucher />} />} />
          <Route path="/banks" element={<ProtectedRoute element={<Banks />} />} />
          <Route path="/banks/add" element={<ProtectedRoute element={<AddBank />} />} />
          <Route path="/banks/edit/:id" element={<ProtectedRoute element={<EditBank />} />} />
          <Route path="/banks/view/:id" element={<ProtectedRoute element={<ViewBank />} />} />
          <Route path="/bank-accounts" element={<ProtectedRoute element={<BankAccounts />} />} />
          <Route path="/cash-registers" element={<ProtectedRoute element={<CashRegisters />} />} />
          <Route path="/cost-centers" element={<ProtectedRoute element={<CostCenters />} />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
